import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from '../../../models/response/base-response';
import { IDmNguonBietToi } from '../../../models/response/category/IDmNguonBietToi';
import { eNguonBietToiActionTypeIds, INguonBietToiActionTypes } from '../../action-types/crm-category/IDmNguonBietToiActionTypes';
import { actions } from '../../actions/actionsWrapper';


export function* nguonBietToiSaga(): any {
    yield takeLatest(eNguonBietToiActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eNguonBietToiActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eNguonBietToiActionTypeIds.DELETE_START, deleteWorker)


}

function* loadWorker(): any {
    const res: IBaseResponeModel = yield call(apiWrapper.crmCategoryWrapper.nguonBietToi.select_all)
    if (res.is_success) {
        yield put(actions.crmCategoryWrapper.nguonBietToi.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.crmCategoryWrapper.nguonBietToi.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* saveWorker(action: INguonBietToiActionTypes): any {
    const payload: IDmNguonBietToi = action.payload as IDmNguonBietToi;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.crmCategoryWrapper.nguonBietToi.update, payload)
    } else {
        res = yield call(apiWrapper.crmCategoryWrapper.nguonBietToi.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.crmCategoryWrapper.nguonBietToi.SAVE_SUCESS(res.data))
    } else {
        yield put(actions.crmCategoryWrapper.nguonBietToi.SAVE_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: INguonBietToiActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.crmCategoryWrapper.nguonBietToi.delete, payload)
    if (res.is_success) {
        yield put(actions.crmCategoryWrapper.nguonBietToi.DELETE_SUCESS(undefined))
    } else {
        yield put(actions.crmCategoryWrapper.nguonBietToi.DELETE_ERROR(res.message ?? "Error"))
    }
}
